import { CategoriesEntity } from 'libs/gb-dashboard/item/data-access-categories/src/lib/+state/categories.models'
import {
  ItemTypeEnum,
  SlimBiddingItemsEntity,
  SlimItemsEntity,
} from 'libs/gb-dashboard/item/data-access/src/lib/+state/items.models'
import { RaffleItemsEntity } from 'libs/gb-dashboard/raffle/data-access/src/lib/+state/raffles.models'
import { DonatedItemProfile } from 'libs/gb-dashboard/item/data-access-donated-item/src/lib/+state/donated-item.models'
import { PdfScan } from 'libs/shared/pdf-uploader/data-access/src/lib/pdf-uploader.models'

export interface ItemsEntity
  extends Omit<SlimItemsEntity, 'bidding_item' | 'donation_item' | 'purchase_item' | 'raffle_item'> {
  bidding_item: BiddingItemsEntity | null
  purchase_item: PurchaseItemsEntity | null
  donation_item: DonationItemsEntity | null
  raffle_item: RaffleItemsEntity | null
  badge: string | null
  description: string
  categories: CategoriesEntity[]
  collection_enabled: boolean
  collection_instructions: string
  donor: ItemDonorEntity | null
  enable_activity_feed: boolean
  enable_ioc_update: boolean
  footnote: string
  ioc_cost_application_fee: boolean
  ioc_shop_label: string | null
  ioc_shop_label_color: string
  item_activity_feed_visibility: boolean
  is_child_item?: boolean
  label: string | null
  lock_message: string
  next_id: string | null
  order_hash: string
  prev_id: string | null
  market_value: number
  share_facebook: boolean
  share_link: boolean
  share_twitter: boolean
  show_badge: boolean
  show_label: boolean
  supplier_agreement: string
  supplier_agreement_expiry: Date | null
  supplier_cost: number | null
  supplier_email: string | null
  supplier_name: string | null
  supplier_notes: string
  supplier_phone: string | null
  voucher_redemption_code_enabled: boolean
  voucher_redemption_instructions: string
  voucher_redemption_terms_and_conditions: string
  voucher_pdf: string | null
  voucher_pdf_scan: PdfScan | null
  voucher_pdf_scan_uuid?: string
  terms_and_conditions: string
  terms_and_conditions_enabled: boolean
}

export interface BiddingItemsEntity extends SlimBiddingItemsEntity {
  auction: string
  bid_strength_enabled: boolean
  bid_strength_percentage: string | null
  has_bidding_purchases: boolean
  bidding_purchases: SlimBiddingPurchasesEntity[]
  hide_bidder: boolean
  hide_price: boolean
  hide_reserve_price: boolean
  hide_status_badge: boolean
  hide_units_available: boolean
  item: string
  item_type: ItemTypeEnum
  minimum_increment: number
  minimum_next_bid: number
  outbid_sms: boolean
  outbid_notification: boolean
  units_available: number
  units_remaining: number
  winning_bids: WinningBidEntity[]
}

export interface SlimBiddingPurchasesEntity {
  profile_full_name: string
  units_purchased: number
  unit_price: number
}

export interface WinningBidEntity {
  amount: number
  auction: string
  bidding_item: string
  created: string
  profile_full_name: string
  item: string
  minimum_next_bid: number
  profile_uuid: string
  uuid: string
  is_pre_bid: boolean
}

export interface PurchaseItemsEntity {
  auction: string
  item: string
  item_type: ItemTypeEnum
  pay_now: boolean
  unit_price: number
  units_available: number
  units_per_person: number
  units_remaining: number
  uuid: string
}

export interface ItemDonorEntity extends DonatedItemProfile {
  donor_display_name: string | null
}

export interface DonationItemsEntity {
  auction: string
  donation_options: number[] | [] | null
  include_other_amount: boolean
  item: string
  item_type: ItemTypeEnum
  minimum_donation: number
  pay_now: boolean
  total_collected: number
  use_increments: boolean
  uuid: string
  target: number
}

export interface BidsResponse {
  uuid: string
  auction: string
  item: string
  bidding_item: string
  profile: string
  amount: number
  delegate: string | null
  created: string
  minimum_next_bid: number
  is_winning_bid: boolean
  payment: string | null
  has_max_bid: boolean
}

export const ITEM_DEFAULTS = {
  iocShopLabelColor: '#ffc107',
}
